const Config = {
  basedomain: process.env.NODE_ENV === 'development' ? (process?.env?.VUE_APP_DEV_BASE_DOMAIN ?? '/') : '/',
};

export default Config;
